import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

type TargetPerilakuConfirmationDialogProps = Omit<DialogProps, 'children'> & {
  onCancel?: () => void
  onConfirm?: () => void
}

export function TargetPerilakuConfirmationDialog({
  onCancel,
  onConfirm,
  ...dialogProps
}: TargetPerilakuConfirmationDialogProps) {
  return (
    <Dialog size="sm" {...dialogProps}>
      <DialogOverlay />
      <DialogContent
        aria-labelledby="praktik-kinerja-target-perilaku-confirmation-dialog-title"
        aria-describedby="praktik-kinerja-target-perilaku-confirmation-dialog-description"
      >
        <div className="p-6 space-y-4">
          <Icon color="critical" className="!text-6xl">
            warning
          </Icon>
          <Text
            variant="heading-md"
            as="h3"
            id="praktik-kinerja-target-perilaku-confirmation-dialog-title"
          >
            Perhatian! Seluruh pengisian dan hasil penilaian Praktik Kinerja
            Anda akan dihapus. Tetap lanjut ubah?
          </Text>
          <div className="flex flex-col bg-blue-5 gap-2 p-3 rounded-md border border-interactive-hovered">
            <Text
              variant="action"
              id="praktik-kinerja-target-perilaku-confirmation-dialog-description"
            >
              Pastikan Anda ingin ubah Target Perilaku dan Upaya Mempelajari
            </Text>
            <Text color="subdued">
              Jika ingin ubah jadwal atau mata pelajaran, diskusikan dengan Tim
              Kinerja di luar sistem.
            </Text>
          </div>
          <div className="flex pt-2 space-x-5">
            <Button onClick={onCancel} color="white" size="lg">
              Kembali
            </Button>
            <Button onClick={onConfirm} color="blue" size="lg">
              Ubah Target Perilaku
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
